// Teal Crystal Super Theme - Icy crystalline aesthetic
const tealCrystal = {
    id: "tealCrystal",
    name: "Kristalli 💎",
    price: 150,
    main: "#0d9488",
    light: "#5eead4",
    dark: "#0f766e",
    bg: "#f0fdfa",
    darkBg: "#0f2b2b",
    contrastText: "#ffffff",
    isSuper: true,
    isDarkTheme: false,
    shape: "square",
    surfaces: {
        // Light mode
        lightBg: '#ccfbf1',
        lightPaper: '#f0fdfa',
        lightContainer: '#f0fdfa',
        lightOnSurface: '#0f2b2b',
        lightOnSurfaceVariant: '#2a5a5a',
        lightOutline: '#4d9090',
        // Dark mode
        containerLowest: '#0f2b2b',
        containerLow: '#061818',
        container: '#0f2b2b',
        containerHigh: '#1a3d3d',
        containerHighest: '#244e4e',
        bright: '#2e6060',
        onSurface: '#d8fff8',
        onSurfaceVariant: '#90d8d0',
        outline: '#4d9090',
        outlineVariant: '#2a5a5a',
        // Button colors — primary
        primaryContainer: '#5eead4',
        onPrimaryContainer: '#003d36',
        // Button colors — secondary (outlined)
        secondaryContainer: '#0a3d3d',
        onSecondaryContainer: '#90d8d0',
        // Button colors — secondary (filled)
        secondary: '#5eead4',
        onSecondary: '#003d36',
        secondaryLight: '#0f766e',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#f0fdfa',
        onInverseSurface: '#0f2b2b',
        inverseSurfaceLight: '#0f2b2b',
        onInverseSurfaceLight: '#d8fff8',
        // Button colors — label/text
        labelColor: '#5eead4',
        labelColorLight: '#0f766e',
        // Status colors
        success: '#4caf50',
        successLight: '#81c784',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    typography: {
        headline: '"Inter", sans-serif',
        body: '"Inter", sans-serif',
    },
    animations: {
        taskComplete: "profileEffect",
        profileEffect: {
            src: "/uploads/profile-effects/moonlit-crystals/effect.json",
            width: 450,
            height: 880,
            scaleToCard: true,
        },
        buttonHover: "shimmer",
        avatar: "glowPulse",
        cardHover: null,
    },
    nameplate: {
        light: {
            src: "/uploads/profile-effects/moonlit-charm/bg.json",
            animateFirst: true,
        },
        dark: {
            src: "/uploads/profile-effects/moonlit-charm/bg.json",
            animateFirst: true,
        },
    },
    effects: {
        glowColor: "#5eead440",
    },
    modes: {
        light: {
            background: "linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 40%, #99f6e4 100%)",
            cardBg: "rgba(255, 255, 255, 0.8)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#0d9488",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(13, 148, 136, 0.6)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
            nameColor: "#0f766e",
        },
        dark: {
            background: "linear-gradient(135deg, #0f2b2b 0%, #0d2222 50%, #0a1a1a 100%)",
            cardBg: "rgba(13, 148, 136, 0.12)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#0d9488",
            coinCompletedText: "#ffffff",
            coinPendingBg: "rgba(13, 148, 136, 0.6)",
            coinPendingText: "#ffffff",
            taskFontWeight: 600,
        },
    },
    components: {
        card: {
            borderRadius: "8px",
            border: "1px solid rgba(13, 148, 136, 0.2)",
            boxShadow: "0 4px 24px rgba(13, 148, 136, 0.08)",
        },
        button: {
            borderRadius: "8px",
        },
        chip: {
            borderRadius: "6px",
        },
        progressBar: {
            borderRadius: 0,
        },
    },
};

export default tealCrystal;
